import { Box, Tabs, Tab } from "../helper";

const useStyle = () => ({
  boxStyle: () => ({ flexGrow: 1, display: "flex", justifyContent: "center" }),
  tabStyle: () => ({
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 32,
    color: "rgba(54, 43, 115, 1)",
  }),
});

export default function ChallanTab({ config, tabIndex, onTabChange }) {
  const styles = useStyle();
  return (
    <Box sx={styles.boxStyle}>
      <Tabs
        value={tabIndex}
        onChange={onTabChange}
        aria-label="disabled tabs example"
        textColor="secondary"
      >
        {config.map(({ action, label }) => (
          <Tab
            sx={styles.tabStyle}
            onClick={action}
            label={label}
            key={label}
          />
        ))}
      </Tabs>
    </Box>
  );
}
